// (function () {
//   'use strict';

//   if (!document.querySelector('product-gallery')) return;

//   var allVariantMediaMap = {};

//   async function fetchProductData() {
//     try {
//       var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
//       if (!match) return;
//       var resp = await fetch('/products/' + match[1] + '.js');
//       var product = await resp.json();

//       product.variants.forEach(function (v) {
//         if (v.featured_media && v.featured_media.id) {
//           allVariantMediaMap[String(v.featured_media.id)] = true;
//         }
//       });

//       console.log('[V&V] Variant media IDs:', Object.keys(allVariantMediaMap));
//     } catch (e) {
//       console.warn('[V&V] Failed to fetch product data:', e);
//     }
//   }

//   function updateStyleTag(currentMediaId) {
//     var styleEl = document.getElementById('vv-variant-thumb-filter');
//     if (!styleEl) return;

//     var currentId = String(currentMediaId);
//     var css = '';

//     Object.keys(allVariantMediaMap).forEach(function (mediaId) {
//       if (mediaId !== currentId) {
//         css += '.product-gallery__thumbnail[data-media-id="' + mediaId + '"] { display: none !important; }\n';
//         css += '.product-gallery__media[data-media-id="' + mediaId + '"] { display: none !important; }\n';
//       }
//     });

//     styleEl.textContent = css;
//     console.log('[V&V] Updated style tag. Showing variant media:', currentId);
//   }

//   function scrollToMedia(mediaId) {
//     var id = String(mediaId);
//     var gallery = document.querySelector('product-gallery');
//     if (!gallery) return;

//     var carousel = gallery.querySelector('.product-gallery__carousel');
//     if (!carousel) return;

//     var cells = carousel.cells;
//     var targetIndex = cells.findIndex(function (cell) {
//       return cell.getAttribute('data-media-id') === id;
//     });

//     if (targetIndex !== -1) {
//       carousel.select(targetIndex, { instant: true });
//       console.log('[V&V] Instantly selected media at index:', targetIndex);
//     } else {
//       console.warn('[V&V] Could not find media in visible cells:', id);
//     }
//   }

//   /**
//    * Find the color option fieldset by checking the <legend> text
//    * against the color labels provided by the theme's Liquid translations.
//    * This is set via: window.__VV_COLOR_LABELS = {{ 'general.label.color' | t | ... | json }};
//    */
//   function findColorFieldset() {
//     var colorLabels = window.__VV_COLOR_LABELS;

//     if (!colorLabels || !colorLabels.length) {
//       console.warn('[V&V] No color labels found. Add the __VV_COLOR_LABELS script tag.');
//       return null;
//     }

//     var fieldsets = document.querySelectorAll('variant-picker .variant-picker__option');

//     for (var i = 0; i < fieldsets.length; i++) {
//       var legend = fieldsets[i].querySelector('legend');
//       if (!legend) continue;

//       // Legend text is like "Color:" — strip colon/whitespace and lowercase
//       var legendText = legend.textContent.replace(/[:\s]/g, '').toLowerCase();

//       for (var j = 0; j < colorLabels.length; j++) {
//         if (legendText === colorLabels[j].trim()) {
//           return fieldsets[i];
//         }
//       }
//     }

//     return null;
//   }

//   /**
//    * On page load, if no ?variant= param in the URL,
//    * deselect the color swatch so no color appears chosen.
//    */
//   function deselectColorIfNoVariantParam() {
//     var params = new URLSearchParams(window.location.search);
//     if (params.has('variant')) return;

//     var colorFieldset = findColorFieldset();
//     if (!colorFieldset) {
//       console.log('[V&V] No color fieldset found');
//       return;
//     }

//     // Uncheck all radio inputs in the color fieldset
//     var radios = colorFieldset.querySelectorAll('input[type="radio"]');
//     radios.forEach(function (radio) {
//       radio.checked = false;
//     });

//     // Clear the selected value display text (the <span> next to the legend)
//     var selectedValueSpan = colorFieldset.querySelector('.variant-picker__option-info .h-stack.gap-1 span');
//     if (selectedValueSpan) {
//       selectedValueSpan.textContent = '';
//     }

//     console.log('[V&V] Deselected default color swatch');
//   }

//   // --- Event listeners ---

//   document.addEventListener('variant:change', function (event) {
//     var variant = event.detail?.variant;
//     if (!variant || !variant.featured_media) return;

//     var mediaId = variant.featured_media.id;
//     console.log('[V&V] Variant changed →', variant.title, '| media:', mediaId);

//     // 1. Update which thumbnails/media are visible
//     updateStyleTag(mediaId);

//     // 2. Instantly switch the gallery to the variant's image
//     requestAnimationFrame(function () {
//       scrollToMedia(mediaId);
//     });
//   });

//   // --- Init ---

//   fetchProductData();
//   deselectColorIfNoVariantParam();
// })();




(function () {
  'use strict';

  if (!document.querySelector('product-gallery')) return;

  var allVariantMediaMap = {};

  async function fetchProductData() {
    try {
      var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var resp = await fetch('/products/' + match[1] + '.js');
      var product = await resp.json();

      product.variants.forEach(function (v) {
        if (v.featured_media && v.featured_media.id) {
          allVariantMediaMap[String(v.featured_media.id)] = true;
        }
      });

      console.log('[V&V] Variant media IDs:', Object.keys(allVariantMediaMap));
    } catch (e) {
      console.warn('[V&V] Failed to fetch product data:', e);
    }
  }

  function updateStyleTag(currentMediaId) {
    var styleEl = document.getElementById('vv-variant-thumb-filter');
    if (!styleEl) return;

    var currentId = String(currentMediaId);
    var css = '';

    Object.keys(allVariantMediaMap).forEach(function (mediaId) {
      if (mediaId !== currentId) {
        css += '.product-gallery__thumbnail[data-media-id="' + mediaId + '"] { display: none !important; }\n';
        css += '.product-gallery__media[data-media-id="' + mediaId + '"] { display: none !important; }\n';
      }
    });

    styleEl.textContent = css;
    console.log('[V&V] Updated style tag. Showing variant media:', currentId);
  }

  function scrollToMedia(mediaId) {
    var id = String(mediaId);
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var cells = carousel.cells;
    var targetIndex = cells.findIndex(function (cell) {
      return cell.getAttribute('data-media-id') === id;
    });

    if (targetIndex !== -1) {
      carousel.select(targetIndex, { instant: true });
      console.log('[V&V] Instantly selected media at index:', targetIndex);
    } else {
      console.warn('[V&V] Could not find media in visible cells:', id);
    }
  }

  function findColorFieldset() {
    var colorLabels = window.__VV_COLOR_LABELS;

    if (!colorLabels || !colorLabels.length) {
      console.warn('[V&V] No color labels found. Add the __VV_COLOR_LABELS script tag.');
      return null;
    }

    var fieldsets = document.querySelectorAll('variant-picker .variant-picker__option');

    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend) continue;

      var legendText = legend.textContent.replace(/[:\s]/g, '').toLowerCase();

      for (var j = 0; j < colorLabels.length; j++) {
        if (legendText === colorLabels[j].trim()) {
          return fieldsets[i];
        }
      }
    }

    return null;
  }

  function deselectColor() {
    var colorFieldset = findColorFieldset();
    if (!colorFieldset) {
      console.log('[V&V] No color fieldset found');
      return;
    }

    var radios = colorFieldset.querySelectorAll('input[type="radio"]');
    radios.forEach(function (radio) {
      radio.checked = false;
    });

    var selectedValueSpan = colorFieldset.querySelector('.variant-picker__option-info .h-stack.gap-1 span');
    if (selectedValueSpan) {
      selectedValueSpan.textContent = '';
    }

    console.log('[V&V] Deselected default color swatch');
  }

  /**
   * Reset the carousel to the first visible cell (index 0).
   * The theme auto-scrolls to the is-initial cell (the default variant image).
   * We override that so the first product image shows instead.
   */
  function resetCarouselToFirst() {
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    // Remove is-initial from all cells so the theme doesn't fight us
    carousel.querySelectorAll('.is-initial').forEach(function (cell) {
      cell.classList.remove('is-initial');
    });

    // Select the first visible cell
    if (carousel.cells && carousel.cells.length > 0) {
      carousel.select(0, { instant: true });
      console.log('[V&V] Reset carousel to first image');
    }
  }

  // --- Event listeners ---

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail?.variant;
    if (!variant || !variant.featured_media) return;

    var mediaId = variant.featured_media.id;
    console.log('[V&V] Variant changed →', variant.title, '| media:', mediaId);

    updateStyleTag(mediaId);

    requestAnimationFrame(function () {
      scrollToMedia(mediaId);
    });
  });

  // --- Init ---

  fetchProductData();

  (function () {
    var params = new URLSearchParams(window.location.search);
    if (params.has('variant')) return;

    // Deselect color swatch
    // deselectColor();

    // Reset carousel to first image after the theme has initialized it
    // Use requestAnimationFrame to ensure the carousel's connectedCallback has run
    requestAnimationFrame(function () {
      resetCarouselToFirst();
    });

    // Re-run deselect if the theme re-renders the variant picker
    // var picker = document.querySelector('variant-picker');
    // if (picker) {
    //   new MutationObserver(function () {
    //     requestAnimationFrame(function () {
    //       var params2 = new URLSearchParams(window.location.search);
    //       if (!params2.has('variant')) {
    //         deselectColor();
    //       }
    //     });
    //   }).observe(picker, { childList: true, subtree: true });
    // }
  })();
})();